import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { DeviceSearchCriteria } from '../models/searchCriteria/DeviceSearchCriteria';
import { Device } from '../models/Device';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: DeviceSearchCriteria): Observable<PagedData<Device>> {
    return this.httpClient.post<PagedData<Device>>(environment.apiUrl + "devices/filtered", searchCriteria);
  }

  get(id: string): Observable<Device> {
    return this.httpClient.get<Device>(environment.apiUrl + "devices/" + id);
  }

  preCoupling(preCouplingKey: String): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "devices/preCoupling/" + preCouplingKey, {});
  }

  save(device: Device): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "devices", device);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "devices/" + id);
  }

  reset(id: string): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "devices/" + id + "/reset", {});
  }
}